import { signOut } from 'aws-amplify/auth'
import { Typography, createStyles, makeStyles } from '@material-ui/core'

export async function handleLogout(): Promise<void> {
  try {
    await signOut({ global: true })
    window.location.replace('/')
  } catch (err) {
    console.error('Error signing out:', err)
  }
}

const SignoutButton = (): JSX.Element => {
  const useStyles = makeStyles(() =>
    createStyles({
      text: { width: '100%', cursor: 'pointer' },
    })
  )
  const classes = useStyles()

  return (
    <Typography className={classes.text} onClick={handleLogout}>
      Abmelden
    </Typography>
  )
}

export default SignoutButton
